<template>
  <Modal
    v-model="_value"
    width="600"
    title="添加维修订单"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="maintainOrder" :label-width="100" >
      <Row>
        <Col span="12">
      <FormItem prop="businessUserId" label="问题车辆">
        <Select placeholder="请选择车辆"
                v-model="maintainOrder.vehicleInfoId"
                filterable
                remote
                :remote-method="searchVehicleInfo"
                :loading="searchVehicleInfoLoading"
                class="field"
                @on-select="onselect"
                clearable>
          <Option v-for="(option, index) in searchVehicleInfoList" :value="option.id" :key="option.id">{{option.registrationNum==null?option.vin:option.registrationNum}}</Option>
        </Select>
      </FormItem>
        </Col>
        <Col span="12">
      <FormItem prop="positioningDeviceInfo" label="问题设备">
        <Select v-model="maintainOrder.positioningDeviceInfos" multiple>
          <Option v-for="item in positioningDeviceInfosTypeOptions" :value="item" :key="item.terminalNum">
            {{item.terminalNum + '(' + item.positioningDeviceModel.name + ')'}}
          </Option>
        </Select>
      </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12" v-if="maintainOrder.positioningDeviceInfos.length > 0">
          <div v-for="item in maintainOrder.positioningDeviceInfos">
            <FormItem v-if="item.serviceState == 0" prop="positioningDeviceInfo" label="停止服务状态：" style="color: red;">
              {{item.terminalNum + '(' + item.positioningDeviceModel.name + ')'}}
            </FormItem>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span="12">
          <FormItem prop="businessUserId" label="维修时间">
            <DatePicker type="datetime" v-model="maintainOrder.bookingDatetime"
                        placeholder="选择日期"></DatePicker>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem prop="qghyptOption" label="维修地点">
            <Input class="field" v-model="maintainOrder.bookingPlace">
            </Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="12">
      <FormItem prop="question" label="订单类型">
        <Select v-model="maintainOrder.maintainType">
          <Option v-for="item in maintainTypeOptions" :value="item.value" :key="item.value">
            {{item.name}}
          </Option>
        </Select>
      </FormItem>
        </Col>
        <Col span="12">
      <FormItem prop="maintainerId" label="维修员">
        <Select class="field" v-model="maintainOrder.maintainerId">
          <Option v-for="item in maintainers" :value="item.value" :key="item.label">{{item.label}}</Option>
        </Select>
      </FormItem>
        </Col>
      </Row>
      <Row>
<!--        <Col span="12">-->
<!--          <FormItem prop="businessUserId" label="是否已收款">-->
<!--            <RadioGroup v-model="maintainOrder.receptDatetime">-->
<!--              <Radio label="是"></Radio>-->
<!--              <Radio label="否"></Radio>-->
<!--            </RadioGroup>-->
<!--          </FormItem>-->
<!--        </Col>-->
        <Col span="12">
          <FormItem prop="qghyptOption" label="是否加急">
            <Space direction="vertical" size="large">
              <RadioGroup v-model="maintainOrder.urgent">
                <Radio label="是"></Radio>
                <Radio label="否"></Radio>
              </RadioGroup>
            </Space>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
      <FormItem prop="question" label="问题描述">
        <Select class="field" v-model="maintainOrder.questionid">
          <Option v-for="item in questionOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
        <Input v-if="maintainOrder.questionid == 1 || maintainOrder.questionid == 9" class="field" v-model="maintainOrder.question" type="textarea">
        </Input>
      </FormItem>
        </Col>
      </Row>
        <Row>
          <Col span="24">
      <FormItem prop="remark" label="备注">
          <Input class="field" v-model="maintainOrder.remark" type="textarea">
          </Input>
      </FormItem>
          </Col>
        </Row>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addmaintainordermodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      searchVehicleInfoLoading: false,
      searchVehicleInfoList: [],

      maintainers: [],

      maintainOrder: {
        businessUserId: null,
        businessUser: null,
        maintainerId: null,
        maintainer: null,
        vehicleInfoId: null,
        vehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            id: null,
            name: null
          },
          vehicleBrand: {
            id: null,
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            id: null,
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        updateDatetime: null,
        bookingDatetime: null,
        bookingPlace: null,
        actualDatetime: null,
        actualPlace: null,
        maintainDatetime: null,
        question: null,
        questionid: 1,
        result: null,
        remark: null,
        maintainDeviceRecords: null,
        maintainType: 0,
        positioningDeviceInfos: [],
        urgent: '否',
        receptDatetime: '否'
      },

      positioningDeviceInfosTypeOptions: [],

      // 维修订单类型
      maintainTypeOptions: [
        { name: '维修', value: 0 },
        { name: '返修', value: 1 }
      ],

      questionOptions: [
        { label: '其他', value: 1 },
        { label: '4G通信天线异常，更换4G通信天线', value: 2 },
        { label: '1D定位，GPS定位天线异常，更换GPS定位天线', value: 3 },
        { label: 'SIM卡异常，更换SIM卡', value: 4 },
        { label: '硬盘异常，更换硬盘', value: 5 },
        { label: 'ACC线路异常，检修ACC线路', value: 6 },
        { label: '显示屏异常，检修显示屏', value: 7 },
        { label: '主机异常，检修主机', value: 8 },
        { label: '摄像头异常，检修摄像头', value: 9 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    searchVehicleInfo (input) {
      this.searchVehicleInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoList = []
        this.searchVehicleInfoLoading = false
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoList = []
          store.getters.get_VehicleInfo_SearchByNameResult.forEach(item => {
            this.searchVehicleInfoList.push(item)
          })
          this.searchVehicleInfoLoading = false
        }).catch(err => {
          this.searchVehicleInfoLoading = false
        })
      }
    },
    /**
     * 选择车辆
     */
    onselect (e) {
      console.log(e)
      store.dispatch('VehicleInfoServ_GetDetail', {
        params: { id: e.value },
        urlparams: null
      }).then(res => {
        console.log(res)
        this.positioningDeviceInfosTypeOptions = store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos
      }).catch(err => {
        console.log(err)
      })
    },
    onOk () {
      if (this.maintainOrder.receptDatetime == '是') {
        this.maintainOrder.receptDatetime = new Date()
      } else {
        this.maintainOrder.receptDatetime = null
      }
      if (this.maintainOrder.urgent == '是') {
        this.maintainOrder.urgent = true
      } else {
        this.maintainOrder.urgent = false
      }

      this.questionOptions.forEach(item => {
        if (item.value != 1 && item.value != 9) {
          if (this.maintainOrder.questionid == item.value) {
            this.maintainOrder.question = item.label
            return
          }
        }
        if (item.value == 9) {
          if (this.maintainOrder.questionid == item.value) {
            this.maintainOrder.question = item.label + ':' + this.maintainOrder.question
          }
        }
      })

      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认添加维修订单</p>',
        onOk: () => {
          console.log(this.maintainOrder)
          if (this.maintainOrder.remark != null) {
            if (this.maintainOrder.positioningDeviceInfos.length > 0) {
              this.maintainOrder.remark += ',需维修设备:'
              for (let i = 0; i < this.maintainOrder.positioningDeviceInfos.length; i++) {
                this.maintainOrder.remark += this.maintainOrder.positioningDeviceInfos[i].positioningDeviceModel.name + ','
              }
            }
          } else {
            if (this.maintainOrder.positioningDeviceInfos.length > 0) {
              this.maintainOrder.remark = '需维修设备:'
              for (let i = 0; i < this.maintainOrder.positioningDeviceInfos.length; i++) {
                this.maintainOrder.remark += this.maintainOrder.positioningDeviceInfos[i].positioningDeviceModel.name + ','
              }
            }
          }
          // console.log(this.maintainOrder.remark)
          store.dispatch('MaintainOrderServ_AddObj', { params: this.maintainOrder }).then(() => {
            this.$Message.success('添加维修订单成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        if (this._initValue != null) {
          this.searchVehicleInfo(this._initValue)
        }
        this.maintainOrder.vehicleInfoId = null
        this.maintainOrder.bookingDatetime = null
        this.maintainOrder.maintainType = 0
        this.maintainOrder.urgent = '否'
        this.maintainOrder.question = null
        this.maintainOrder.remark = null
        this.maintainOrder.positioningDeviceInfos = []
        this.positioningDeviceInfosTypeOptions = []
      }
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8, 14] }
      }).then(() => {
        // this.maintainers = store.getters.get_User_GetAllUsersResult
        let maintainerss = store.getters.get_User_GetAllUsersResult
        maintainerss.forEach(item => {
          if (item.state === 1){
            // console.log(item.id)
            // console.log(item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name)
            this.maintainers.push({ label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id })
          }
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
